(function () {
  // Elements the Judge.me widget ships with ARIA ID-references that point at
  // elements it never renders:
  //   .mw-tooltip--icon / .mw-label      — Mantine internals (aria-describedby)
  //   .jdgm-tab[role='tab']              — the Reviews / Questions tablist. Judge.me
  //                                        sets aria-controls='jdgm-tabpanel_*' but
  //                                        emits NO tabpanel element at all, so the
  //                                        reference dangles on every PDP.
  var SELECTOR = '.mw-tooltip--icon, .mw-label, .jdgm-tab[role="tab"]';
  var ID_REF_ATTRS = ['aria-controls', 'aria-describedby'];

  // A dangling ARIA ID-reference is worse than an absent one: assistive tech
  // announces a control that leads nowhere, and axe/Lighthouse fail it as
  // aria-valid-attr-value. role='tab' remains valid without aria-controls.
  function forEachDanglingRef(fn) {
    var els = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < els.length; i++) {
      for (var j = 0; j < ID_REF_ATTRS.length; j++) {
        var attr = ID_REF_ATTRS[j];
        var targetId = els[i].getAttribute(attr);
        if (targetId && !document.getElementById(targetId)) {
          if (fn(els[i], attr) === false) return false;
        }
      }
    }
    return true;
  }

  function fixJudgemeAria() {
    forEachDanglingRef(function (el, attr) {
      el.removeAttribute(attr);
    });
  }

  function hasDanglingRefs() {
    var found = false;
    forEachDanglingRef(function () {
      found = true;
      return false; // short-circuit
    });
    return found;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixJudgemeAria);
  } else {
    fixJudgemeAria();
  }

  // Watch for widget DOM injection and re-run on each mutation batch. Judge.me
  // injects in several phases (Mantine chrome first, the tablist later), so the
  // observer must survive past the first batch — disconnecting on the first
  // marker class alone would leave any later-injected element unpatched.
  // Disconnect only once nothing dangling remains; the 10s timer is the backstop
  // for pages where a phase never arrives.
  var container = document.getElementById('judgeme_product_reviews');
  if (container) {
    var safetyTimer;
    var obs = new MutationObserver(function () {
      fixJudgemeAria();
      if (!hasDanglingRefs() && document.querySelector(SELECTOR)) {
        obs.disconnect();
        clearTimeout(safetyTimer);
      }
    });
    obs.observe(container, { childList: true, subtree: true });
    // Safety: disconnect after 10s to prevent a permanently-live observer if a
    // widget phase never lands.
    safetyTimer = setTimeout(function () {
      obs.disconnect();
    }, 10000);
  }
  // 2s backstop: runs if the widget injected before the observer was set up, or
  // the container wasn't in the DOM yet.
  setTimeout(fixJudgemeAria, 2000);
})();
